import { render, staticRenderFns } from "./CenterToaster.vue?vue&type=template&id=3dc3a50a"
import script from "./CenterToaster.vue?vue&type=script&lang=js"
export * from "./CenterToaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports